/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailPendingRouteImport } from './routes/verify-email-pending'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as LoginRouteImport } from './routes/login'
import { Route as JoinRouteImport } from './routes/join'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as AcceptInvitationRouteImport } from './routes/accept-invitation'
import { Route as ContextRouteImport } from './routes/_context'
import { Route as ContextIndexRouteImport } from './routes/_context/index'
import { Route as ContextNewIndexRouteImport } from './routes/_context/new/index'
import { Route as ContextOrgsOrganizationRouteImport } from './routes/_context/orgs.$organization'
import { Route as ContextNsNamespaceRouteImport } from './routes/_context/ns.$namespace'
import { Route as ContextOrgsOrganizationIndexRouteImport } from './routes/_context/orgs.$organization/index'
import { Route as ContextNsNamespaceIndexRouteImport } from './routes/_context/ns.$namespace/index'
import { Route as ContextNsNamespaceSettingsRouteImport } from './routes/_context/ns.$namespace/settings'
import { Route as ContextOrgsOrganizationProjectsIndexRouteImport } from './routes/_context/orgs.$organization/projects.index'
import { Route as ContextOrgsOrganizationNewIndexRouteImport } from './routes/_context/orgs.$organization/new/index'
import { Route as ContextOrgsOrganizationProjectsProjectRouteImport } from './routes/_context/orgs.$organization/projects.$project'
import { Route as ContextOrgsOrganizationProjectsProjectIndexRouteImport } from './routes/_context/orgs.$organization/projects.$project/index'
import { Route as ContextOrgsOrganizationProjectsProjectSettingsRouteImport } from './routes/_context/orgs.$organization/projects.$project/settings'
import { Route as ContextOrgsOrganizationProjectsProjectMetricsRouteImport } from './routes/_context/orgs.$organization/projects.$project/metrics'
import { Route as ContextOrgsOrganizationProjectsProjectBillingRouteImport } from './routes/_context/orgs.$organization/projects.$project/billing'
import { Route as ContextOrgsOrganizationProjectsProjectNsNamespaceRouteImport } from './routes/_context/orgs.$organization/projects.$project/ns.$namespace'
import { Route as ContextOrgsOrganizationProjectsProjectNsNamespaceIndexRouteImport } from './routes/_context/orgs.$organization/projects.$project/ns.$namespace/index'
import { Route as ContextOrgsOrganizationProjectsProjectNsNamespaceTokensRouteImport } from './routes/_context/orgs.$organization/projects.$project/ns.$namespace/tokens'
import { Route as ContextOrgsOrganizationProjectsProjectNsNamespaceSettingsRouteImport } from './routes/_context/orgs.$organization/projects.$project/ns.$namespace/settings'
import { Route as ContextOrgsOrganizationProjectsProjectNsNamespaceMetricsRouteImport } from './routes/_context/orgs.$organization/projects.$project/ns.$namespace/metrics'
import { Route as ContextOrgsOrganizationProjectsProjectNsNamespaceLogsRouteImport } from './routes/_context/orgs.$organization/projects.$project/ns.$namespace/logs'
import { Route as ContextOrgsOrganizationProjectsProjectNsNamespaceDeploymentsRouteImport } from './routes/_context/orgs.$organization/projects.$project/ns.$namespace/deployments'
import { Route as ContextOrgsOrganizationProjectsProjectNsNamespaceConnectRouteImport } from './routes/_context/orgs.$organization/projects.$project/ns.$namespace/connect'
import { Route as ContextOrgsOrganizationProjectsProjectNsNamespaceBillingRouteImport } from './routes/_context/orgs.$organization/projects.$project/ns.$namespace/billing'

const VerifyEmailPendingRoute = VerifyEmailPendingRouteImport.update({
  id: '/verify-email-pending',
  path: '/verify-email-pending',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const JoinRoute = JoinRouteImport.update({
  id: '/join',
  path: '/join',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInvitationRoute = AcceptInvitationRouteImport.update({
  id: '/accept-invitation',
  path: '/accept-invitation',
  getParentRoute: () => rootRouteImport,
} as any)
const ContextRoute = ContextRouteImport.update({
  id: '/_context',
  getParentRoute: () => rootRouteImport,
} as any)
const ContextIndexRoute = ContextIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ContextRoute,
} as any)
const ContextNewIndexRoute = ContextNewIndexRouteImport.update({
  id: '/new/',
  path: '/new/',
  getParentRoute: () => ContextRoute,
} as any)
const ContextOrgsOrganizationRoute = ContextOrgsOrganizationRouteImport.update({
  id: '/orgs/$organization',
  path: '/orgs/$organization',
  getParentRoute: () => ContextRoute,
} as any)
const ContextNsNamespaceRoute = ContextNsNamespaceRouteImport.update({
  id: '/ns/$namespace',
  path: '/ns/$namespace',
  getParentRoute: () => ContextRoute,
} as any)
const ContextOrgsOrganizationIndexRoute =
  ContextOrgsOrganizationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ContextOrgsOrganizationRoute,
  } as any)
const ContextNsNamespaceIndexRoute = ContextNsNamespaceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ContextNsNamespaceRoute,
} as any)
const ContextNsNamespaceSettingsRoute =
  ContextNsNamespaceSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => ContextNsNamespaceRoute,
  } as any)
const ContextOrgsOrganizationProjectsIndexRoute =
  ContextOrgsOrganizationProjectsIndexRouteImport.update({
    id: '/projects/',
    path: '/projects/',
    getParentRoute: () => ContextOrgsOrganizationRoute,
  } as any)
const ContextOrgsOrganizationNewIndexRoute =
  ContextOrgsOrganizationNewIndexRouteImport.update({
    id: '/new/',
    path: '/new/',
    getParentRoute: () => ContextOrgsOrganizationRoute,
  } as any)
const ContextOrgsOrganizationProjectsProjectRoute =
  ContextOrgsOrganizationProjectsProjectRouteImport.update({
    id: '/projects/$project',
    path: '/projects/$project',
    getParentRoute: () => ContextOrgsOrganizationRoute,
  } as any)
const ContextOrgsOrganizationProjectsProjectIndexRoute =
  ContextOrgsOrganizationProjectsProjectIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ContextOrgsOrganizationProjectsProjectRoute,
  } as any)
const ContextOrgsOrganizationProjectsProjectSettingsRoute =
  ContextOrgsOrganizationProjectsProjectSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => ContextOrgsOrganizationProjectsProjectRoute,
  } as any)
const ContextOrgsOrganizationProjectsProjectMetricsRoute =
  ContextOrgsOrganizationProjectsProjectMetricsRouteImport.update({
    id: '/metrics',
    path: '/metrics',
    getParentRoute: () => ContextOrgsOrganizationProjectsProjectRoute,
  } as any)
const ContextOrgsOrganizationProjectsProjectBillingRoute =
  ContextOrgsOrganizationProjectsProjectBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => ContextOrgsOrganizationProjectsProjectRoute,
  } as any)
const ContextOrgsOrganizationProjectsProjectNsNamespaceRoute =
  ContextOrgsOrganizationProjectsProjectNsNamespaceRouteImport.update({
    id: '/ns/$namespace',
    path: '/ns/$namespace',
    getParentRoute: () => ContextOrgsOrganizationProjectsProjectRoute,
  } as any)
const ContextOrgsOrganizationProjectsProjectNsNamespaceIndexRoute =
  ContextOrgsOrganizationProjectsProjectNsNamespaceIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      ContextOrgsOrganizationProjectsProjectNsNamespaceRoute,
  } as any)
const ContextOrgsOrganizationProjectsProjectNsNamespaceTokensRoute =
  ContextOrgsOrganizationProjectsProjectNsNamespaceTokensRouteImport.update({
    id: '/tokens',
    path: '/tokens',
    getParentRoute: () =>
      ContextOrgsOrganizationProjectsProjectNsNamespaceRoute,
  } as any)
const ContextOrgsOrganizationProjectsProjectNsNamespaceSettingsRoute =
  ContextOrgsOrganizationProjectsProjectNsNamespaceSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () =>
      ContextOrgsOrganizationProjectsProjectNsNamespaceRoute,
  } as any)
const ContextOrgsOrganizationProjectsProjectNsNamespaceMetricsRoute =
  ContextOrgsOrganizationProjectsProjectNsNamespaceMetricsRouteImport.update({
    id: '/metrics',
    path: '/metrics',
    getParentRoute: () =>
      ContextOrgsOrganizationProjectsProjectNsNamespaceRoute,
  } as any)
const ContextOrgsOrganizationProjectsProjectNsNamespaceLogsRoute =
  ContextOrgsOrganizationProjectsProjectNsNamespaceLogsRouteImport.update({
    id: '/logs',
    path: '/logs',
    getParentRoute: () =>
      ContextOrgsOrganizationProjectsProjectNsNamespaceRoute,
  } as any)
const ContextOrgsOrganizationProjectsProjectNsNamespaceDeploymentsRoute =
  ContextOrgsOrganizationProjectsProjectNsNamespaceDeploymentsRouteImport.update(
    {
      id: '/deployments',
      path: '/deployments',
      getParentRoute: () =>
        ContextOrgsOrganizationProjectsProjectNsNamespaceRoute,
    } as any,
  )
const ContextOrgsOrganizationProjectsProjectNsNamespaceConnectRoute =
  ContextOrgsOrganizationProjectsProjectNsNamespaceConnectRouteImport.update({
    id: '/connect',
    path: '/connect',
    getParentRoute: () =>
      ContextOrgsOrganizationProjectsProjectNsNamespaceRoute,
  } as any)
const ContextOrgsOrganizationProjectsProjectNsNamespaceBillingRoute =
  ContextOrgsOrganizationProjectsProjectNsNamespaceBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () =>
      ContextOrgsOrganizationProjectsProjectNsNamespaceRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof ContextIndexRoute
  '/accept-invitation': typeof AcceptInvitationRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/join': typeof JoinRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/verify-email-pending': typeof VerifyEmailPendingRoute
  '/ns/$namespace': typeof ContextNsNamespaceRouteWithChildren
  '/orgs/$organization': typeof ContextOrgsOrganizationRouteWithChildren
  '/new/': typeof ContextNewIndexRoute
  '/ns/$namespace/settings': typeof ContextNsNamespaceSettingsRoute
  '/ns/$namespace/': typeof ContextNsNamespaceIndexRoute
  '/orgs/$organization/': typeof ContextOrgsOrganizationIndexRoute
  '/orgs/$organization/projects/$project': typeof ContextOrgsOrganizationProjectsProjectRouteWithChildren
  '/orgs/$organization/new/': typeof ContextOrgsOrganizationNewIndexRoute
  '/orgs/$organization/projects/': typeof ContextOrgsOrganizationProjectsIndexRoute
  '/orgs/$organization/projects/$project/billing': typeof ContextOrgsOrganizationProjectsProjectBillingRoute
  '/orgs/$organization/projects/$project/metrics': typeof ContextOrgsOrganizationProjectsProjectMetricsRoute
  '/orgs/$organization/projects/$project/settings': typeof ContextOrgsOrganizationProjectsProjectSettingsRoute
  '/orgs/$organization/projects/$project/': typeof ContextOrgsOrganizationProjectsProjectIndexRoute
  '/orgs/$organization/projects/$project/ns/$namespace': typeof ContextOrgsOrganizationProjectsProjectNsNamespaceRouteWithChildren
  '/orgs/$organization/projects/$project/ns/$namespace/billing': typeof ContextOrgsOrganizationProjectsProjectNsNamespaceBillingRoute
  '/orgs/$organization/projects/$project/ns/$namespace/connect': typeof ContextOrgsOrganizationProjectsProjectNsNamespaceConnectRoute
  '/orgs/$organization/projects/$project/ns/$namespace/deployments': typeof ContextOrgsOrganizationProjectsProjectNsNamespaceDeploymentsRoute
  '/orgs/$organization/projects/$project/ns/$namespace/logs': typeof ContextOrgsOrganizationProjectsProjectNsNamespaceLogsRoute
  '/orgs/$organization/projects/$project/ns/$namespace/metrics': typeof ContextOrgsOrganizationProjectsProjectNsNamespaceMetricsRoute
  '/orgs/$organization/projects/$project/ns/$namespace/settings': typeof ContextOrgsOrganizationProjectsProjectNsNamespaceSettingsRoute
  '/orgs/$organization/projects/$project/ns/$namespace/tokens': typeof ContextOrgsOrganizationProjectsProjectNsNamespaceTokensRoute
  '/orgs/$organization/projects/$project/ns/$namespace/': typeof ContextOrgsOrganizationProjectsProjectNsNamespaceIndexRoute
}
export interface FileRoutesByTo {
  '/accept-invitation': typeof AcceptInvitationRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/join': typeof JoinRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/verify-email-pending': typeof VerifyEmailPendingRoute
  '/': typeof ContextIndexRoute
  '/new': typeof ContextNewIndexRoute
  '/ns/$namespace/settings': typeof ContextNsNamespaceSettingsRoute
  '/ns/$namespace': typeof ContextNsNamespaceIndexRoute
  '/orgs/$organization': typeof ContextOrgsOrganizationIndexRoute
  '/orgs/$organization/new': typeof ContextOrgsOrganizationNewIndexRoute
  '/orgs/$organization/projects': typeof ContextOrgsOrganizationProjectsIndexRoute
  '/orgs/$organization/projects/$project/billing': typeof ContextOrgsOrganizationProjectsProjectBillingRoute
  '/orgs/$organization/projects/$project/metrics': typeof ContextOrgsOrganizationProjectsProjectMetricsRoute
  '/orgs/$organization/projects/$project/settings': typeof ContextOrgsOrganizationProjectsProjectSettingsRoute
  '/orgs/$organization/projects/$project': typeof ContextOrgsOrganizationProjectsProjectIndexRoute
  '/orgs/$organization/projects/$project/ns/$namespace/billing': typeof ContextOrgsOrganizationProjectsProjectNsNamespaceBillingRoute
  '/orgs/$organization/projects/$project/ns/$namespace/connect': typeof ContextOrgsOrganizationProjectsProjectNsNamespaceConnectRoute
  '/orgs/$organization/projects/$project/ns/$namespace/deployments': typeof ContextOrgsOrganizationProjectsProjectNsNamespaceDeploymentsRoute
  '/orgs/$organization/projects/$project/ns/$namespace/logs': typeof ContextOrgsOrganizationProjectsProjectNsNamespaceLogsRoute
  '/orgs/$organization/projects/$project/ns/$namespace/metrics': typeof ContextOrgsOrganizationProjectsProjectNsNamespaceMetricsRoute
  '/orgs/$organization/projects/$project/ns/$namespace/settings': typeof ContextOrgsOrganizationProjectsProjectNsNamespaceSettingsRoute
  '/orgs/$organization/projects/$project/ns/$namespace/tokens': typeof ContextOrgsOrganizationProjectsProjectNsNamespaceTokensRoute
  '/orgs/$organization/projects/$project/ns/$namespace': typeof ContextOrgsOrganizationProjectsProjectNsNamespaceIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_context': typeof ContextRouteWithChildren
  '/accept-invitation': typeof AcceptInvitationRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/join': typeof JoinRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/verify-email-pending': typeof VerifyEmailPendingRoute
  '/_context/': typeof ContextIndexRoute
  '/_context/ns/$namespace': typeof ContextNsNamespaceRouteWithChildren
  '/_context/orgs/$organization': typeof ContextOrgsOrganizationRouteWithChildren
  '/_context/new/': typeof ContextNewIndexRoute
  '/_context/ns/$namespace/settings': typeof ContextNsNamespaceSettingsRoute
  '/_context/ns/$namespace/': typeof ContextNsNamespaceIndexRoute
  '/_context/orgs/$organization/': typeof ContextOrgsOrganizationIndexRoute
  '/_context/orgs/$organization/projects/$project': typeof ContextOrgsOrganizationProjectsProjectRouteWithChildren
  '/_context/orgs/$organization/new/': typeof ContextOrgsOrganizationNewIndexRoute
  '/_context/orgs/$organization/projects/': typeof ContextOrgsOrganizationProjectsIndexRoute
  '/_context/orgs/$organization/projects/$project/billing': typeof ContextOrgsOrganizationProjectsProjectBillingRoute
  '/_context/orgs/$organization/projects/$project/metrics': typeof ContextOrgsOrganizationProjectsProjectMetricsRoute
  '/_context/orgs/$organization/projects/$project/settings': typeof ContextOrgsOrganizationProjectsProjectSettingsRoute
  '/_context/orgs/$organization/projects/$project/': typeof ContextOrgsOrganizationProjectsProjectIndexRoute
  '/_context/orgs/$organization/projects/$project/ns/$namespace': typeof ContextOrgsOrganizationProjectsProjectNsNamespaceRouteWithChildren
  '/_context/orgs/$organization/projects/$project/ns/$namespace/billing': typeof ContextOrgsOrganizationProjectsProjectNsNamespaceBillingRoute
  '/_context/orgs/$organization/projects/$project/ns/$namespace/connect': typeof ContextOrgsOrganizationProjectsProjectNsNamespaceConnectRoute
  '/_context/orgs/$organization/projects/$project/ns/$namespace/deployments': typeof ContextOrgsOrganizationProjectsProjectNsNamespaceDeploymentsRoute
  '/_context/orgs/$organization/projects/$project/ns/$namespace/logs': typeof ContextOrgsOrganizationProjectsProjectNsNamespaceLogsRoute
  '/_context/orgs/$organization/projects/$project/ns/$namespace/metrics': typeof ContextOrgsOrganizationProjectsProjectNsNamespaceMetricsRoute
  '/_context/orgs/$organization/projects/$project/ns/$namespace/settings': typeof ContextOrgsOrganizationProjectsProjectNsNamespaceSettingsRoute
  '/_context/orgs/$organization/projects/$project/ns/$namespace/tokens': typeof ContextOrgsOrganizationProjectsProjectNsNamespaceTokensRoute
  '/_context/orgs/$organization/projects/$project/ns/$namespace/': typeof ContextOrgsOrganizationProjectsProjectNsNamespaceIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accept-invitation'
    | '/forgot-password'
    | '/join'
    | '/login'
    | '/onboarding'
    | '/reset-password'
    | '/verify-email-pending'
    | '/ns/$namespace'
    | '/orgs/$organization'
    | '/new/'
    | '/ns/$namespace/settings'
    | '/ns/$namespace/'
    | '/orgs/$organization/'
    | '/orgs/$organization/projects/$project'
    | '/orgs/$organization/new/'
    | '/orgs/$organization/projects/'
    | '/orgs/$organization/projects/$project/billing'
    | '/orgs/$organization/projects/$project/metrics'
    | '/orgs/$organization/projects/$project/settings'
    | '/orgs/$organization/projects/$project/'
    | '/orgs/$organization/projects/$project/ns/$namespace'
    | '/orgs/$organization/projects/$project/ns/$namespace/billing'
    | '/orgs/$organization/projects/$project/ns/$namespace/connect'
    | '/orgs/$organization/projects/$project/ns/$namespace/deployments'
    | '/orgs/$organization/projects/$project/ns/$namespace/logs'
    | '/orgs/$organization/projects/$project/ns/$namespace/metrics'
    | '/orgs/$organization/projects/$project/ns/$namespace/settings'
    | '/orgs/$organization/projects/$project/ns/$namespace/tokens'
    | '/orgs/$organization/projects/$project/ns/$namespace/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/accept-invitation'
    | '/forgot-password'
    | '/join'
    | '/login'
    | '/onboarding'
    | '/reset-password'
    | '/verify-email-pending'
    | '/'
    | '/new'
    | '/ns/$namespace/settings'
    | '/ns/$namespace'
    | '/orgs/$organization'
    | '/orgs/$organization/new'
    | '/orgs/$organization/projects'
    | '/orgs/$organization/projects/$project/billing'
    | '/orgs/$organization/projects/$project/metrics'
    | '/orgs/$organization/projects/$project/settings'
    | '/orgs/$organization/projects/$project'
    | '/orgs/$organization/projects/$project/ns/$namespace/billing'
    | '/orgs/$organization/projects/$project/ns/$namespace/connect'
    | '/orgs/$organization/projects/$project/ns/$namespace/deployments'
    | '/orgs/$organization/projects/$project/ns/$namespace/logs'
    | '/orgs/$organization/projects/$project/ns/$namespace/metrics'
    | '/orgs/$organization/projects/$project/ns/$namespace/settings'
    | '/orgs/$organization/projects/$project/ns/$namespace/tokens'
    | '/orgs/$organization/projects/$project/ns/$namespace'
  id:
    | '__root__'
    | '/_context'
    | '/accept-invitation'
    | '/forgot-password'
    | '/join'
    | '/login'
    | '/onboarding'
    | '/reset-password'
    | '/verify-email-pending'
    | '/_context/'
    | '/_context/ns/$namespace'
    | '/_context/orgs/$organization'
    | '/_context/new/'
    | '/_context/ns/$namespace/settings'
    | '/_context/ns/$namespace/'
    | '/_context/orgs/$organization/'
    | '/_context/orgs/$organization/projects/$project'
    | '/_context/orgs/$organization/new/'
    | '/_context/orgs/$organization/projects/'
    | '/_context/orgs/$organization/projects/$project/billing'
    | '/_context/orgs/$organization/projects/$project/metrics'
    | '/_context/orgs/$organization/projects/$project/settings'
    | '/_context/orgs/$organization/projects/$project/'
    | '/_context/orgs/$organization/projects/$project/ns/$namespace'
    | '/_context/orgs/$organization/projects/$project/ns/$namespace/billing'
    | '/_context/orgs/$organization/projects/$project/ns/$namespace/connect'
    | '/_context/orgs/$organization/projects/$project/ns/$namespace/deployments'
    | '/_context/orgs/$organization/projects/$project/ns/$namespace/logs'
    | '/_context/orgs/$organization/projects/$project/ns/$namespace/metrics'
    | '/_context/orgs/$organization/projects/$project/ns/$namespace/settings'
    | '/_context/orgs/$organization/projects/$project/ns/$namespace/tokens'
    | '/_context/orgs/$organization/projects/$project/ns/$namespace/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  ContextRoute: typeof ContextRouteWithChildren
  AcceptInvitationRoute: typeof AcceptInvitationRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  JoinRoute: typeof JoinRoute
  LoginRoute: typeof LoginRoute
  OnboardingRoute: typeof OnboardingRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  VerifyEmailPendingRoute: typeof VerifyEmailPendingRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email-pending': {
      id: '/verify-email-pending'
      path: '/verify-email-pending'
      fullPath: '/verify-email-pending'
      preLoaderRoute: typeof VerifyEmailPendingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join': {
      id: '/join'
      path: '/join'
      fullPath: '/join'
      preLoaderRoute: typeof JoinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invitation': {
      id: '/accept-invitation'
      path: '/accept-invitation'
      fullPath: '/accept-invitation'
      preLoaderRoute: typeof AcceptInvitationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_context': {
      id: '/_context'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ContextRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_context/': {
      id: '/_context/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ContextIndexRouteImport
      parentRoute: typeof ContextRoute
    }
    '/_context/new/': {
      id: '/_context/new/'
      path: '/new'
      fullPath: '/new/'
      preLoaderRoute: typeof ContextNewIndexRouteImport
      parentRoute: typeof ContextRoute
    }
    '/_context/orgs/$organization': {
      id: '/_context/orgs/$organization'
      path: '/orgs/$organization'
      fullPath: '/orgs/$organization'
      preLoaderRoute: typeof ContextOrgsOrganizationRouteImport
      parentRoute: typeof ContextRoute
    }
    '/_context/ns/$namespace': {
      id: '/_context/ns/$namespace'
      path: '/ns/$namespace'
      fullPath: '/ns/$namespace'
      preLoaderRoute: typeof ContextNsNamespaceRouteImport
      parentRoute: typeof ContextRoute
    }
    '/_context/orgs/$organization/': {
      id: '/_context/orgs/$organization/'
      path: '/'
      fullPath: '/orgs/$organization/'
      preLoaderRoute: typeof ContextOrgsOrganizationIndexRouteImport
      parentRoute: typeof ContextOrgsOrganizationRoute
    }
    '/_context/ns/$namespace/': {
      id: '/_context/ns/$namespace/'
      path: '/'
      fullPath: '/ns/$namespace/'
      preLoaderRoute: typeof ContextNsNamespaceIndexRouteImport
      parentRoute: typeof ContextNsNamespaceRoute
    }
    '/_context/ns/$namespace/settings': {
      id: '/_context/ns/$namespace/settings'
      path: '/settings'
      fullPath: '/ns/$namespace/settings'
      preLoaderRoute: typeof ContextNsNamespaceSettingsRouteImport
      parentRoute: typeof ContextNsNamespaceRoute
    }
    '/_context/orgs/$organization/projects/': {
      id: '/_context/orgs/$organization/projects/'
      path: '/projects'
      fullPath: '/orgs/$organization/projects/'
      preLoaderRoute: typeof ContextOrgsOrganizationProjectsIndexRouteImport
      parentRoute: typeof ContextOrgsOrganizationRoute
    }
    '/_context/orgs/$organization/new/': {
      id: '/_context/orgs/$organization/new/'
      path: '/new'
      fullPath: '/orgs/$organization/new/'
      preLoaderRoute: typeof ContextOrgsOrganizationNewIndexRouteImport
      parentRoute: typeof ContextOrgsOrganizationRoute
    }
    '/_context/orgs/$organization/projects/$project': {
      id: '/_context/orgs/$organization/projects/$project'
      path: '/projects/$project'
      fullPath: '/orgs/$organization/projects/$project'
      preLoaderRoute: typeof ContextOrgsOrganizationProjectsProjectRouteImport
      parentRoute: typeof ContextOrgsOrganizationRoute
    }
    '/_context/orgs/$organization/projects/$project/': {
      id: '/_context/orgs/$organization/projects/$project/'
      path: '/'
      fullPath: '/orgs/$organization/projects/$project/'
      preLoaderRoute: typeof ContextOrgsOrganizationProjectsProjectIndexRouteImport
      parentRoute: typeof ContextOrgsOrganizationProjectsProjectRoute
    }
    '/_context/orgs/$organization/projects/$project/settings': {
      id: '/_context/orgs/$organization/projects/$project/settings'
      path: '/settings'
      fullPath: '/orgs/$organization/projects/$project/settings'
      preLoaderRoute: typeof ContextOrgsOrganizationProjectsProjectSettingsRouteImport
      parentRoute: typeof ContextOrgsOrganizationProjectsProjectRoute
    }
    '/_context/orgs/$organization/projects/$project/metrics': {
      id: '/_context/orgs/$organization/projects/$project/metrics'
      path: '/metrics'
      fullPath: '/orgs/$organization/projects/$project/metrics'
      preLoaderRoute: typeof ContextOrgsOrganizationProjectsProjectMetricsRouteImport
      parentRoute: typeof ContextOrgsOrganizationProjectsProjectRoute
    }
    '/_context/orgs/$organization/projects/$project/billing': {
      id: '/_context/orgs/$organization/projects/$project/billing'
      path: '/billing'
      fullPath: '/orgs/$organization/projects/$project/billing'
      preLoaderRoute: typeof ContextOrgsOrganizationProjectsProjectBillingRouteImport
      parentRoute: typeof ContextOrgsOrganizationProjectsProjectRoute
    }
    '/_context/orgs/$organization/projects/$project/ns/$namespace': {
      id: '/_context/orgs/$organization/projects/$project/ns/$namespace'
      path: '/ns/$namespace'
      fullPath: '/orgs/$organization/projects/$project/ns/$namespace'
      preLoaderRoute: typeof ContextOrgsOrganizationProjectsProjectNsNamespaceRouteImport
      parentRoute: typeof ContextOrgsOrganizationProjectsProjectRoute
    }
    '/_context/orgs/$organization/projects/$project/ns/$namespace/': {
      id: '/_context/orgs/$organization/projects/$project/ns/$namespace/'
      path: '/'
      fullPath: '/orgs/$organization/projects/$project/ns/$namespace/'
      preLoaderRoute: typeof ContextOrgsOrganizationProjectsProjectNsNamespaceIndexRouteImport
      parentRoute: typeof ContextOrgsOrganizationProjectsProjectNsNamespaceRoute
    }
    '/_context/orgs/$organization/projects/$project/ns/$namespace/tokens': {
      id: '/_context/orgs/$organization/projects/$project/ns/$namespace/tokens'
      path: '/tokens'
      fullPath: '/orgs/$organization/projects/$project/ns/$namespace/tokens'
      preLoaderRoute: typeof ContextOrgsOrganizationProjectsProjectNsNamespaceTokensRouteImport
      parentRoute: typeof ContextOrgsOrganizationProjectsProjectNsNamespaceRoute
    }
    '/_context/orgs/$organization/projects/$project/ns/$namespace/settings': {
      id: '/_context/orgs/$organization/projects/$project/ns/$namespace/settings'
      path: '/settings'
      fullPath: '/orgs/$organization/projects/$project/ns/$namespace/settings'
      preLoaderRoute: typeof ContextOrgsOrganizationProjectsProjectNsNamespaceSettingsRouteImport
      parentRoute: typeof ContextOrgsOrganizationProjectsProjectNsNamespaceRoute
    }
    '/_context/orgs/$organization/projects/$project/ns/$namespace/metrics': {
      id: '/_context/orgs/$organization/projects/$project/ns/$namespace/metrics'
      path: '/metrics'
      fullPath: '/orgs/$organization/projects/$project/ns/$namespace/metrics'
      preLoaderRoute: typeof ContextOrgsOrganizationProjectsProjectNsNamespaceMetricsRouteImport
      parentRoute: typeof ContextOrgsOrganizationProjectsProjectNsNamespaceRoute
    }
    '/_context/orgs/$organization/projects/$project/ns/$namespace/logs': {
      id: '/_context/orgs/$organization/projects/$project/ns/$namespace/logs'
      path: '/logs'
      fullPath: '/orgs/$organization/projects/$project/ns/$namespace/logs'
      preLoaderRoute: typeof ContextOrgsOrganizationProjectsProjectNsNamespaceLogsRouteImport
      parentRoute: typeof ContextOrgsOrganizationProjectsProjectNsNamespaceRoute
    }
    '/_context/orgs/$organization/projects/$project/ns/$namespace/deployments': {
      id: '/_context/orgs/$organization/projects/$project/ns/$namespace/deployments'
      path: '/deployments'
      fullPath: '/orgs/$organization/projects/$project/ns/$namespace/deployments'
      preLoaderRoute: typeof ContextOrgsOrganizationProjectsProjectNsNamespaceDeploymentsRouteImport
      parentRoute: typeof ContextOrgsOrganizationProjectsProjectNsNamespaceRoute
    }
    '/_context/orgs/$organization/projects/$project/ns/$namespace/connect': {
      id: '/_context/orgs/$organization/projects/$project/ns/$namespace/connect'
      path: '/connect'
      fullPath: '/orgs/$organization/projects/$project/ns/$namespace/connect'
      preLoaderRoute: typeof ContextOrgsOrganizationProjectsProjectNsNamespaceConnectRouteImport
      parentRoute: typeof ContextOrgsOrganizationProjectsProjectNsNamespaceRoute
    }
    '/_context/orgs/$organization/projects/$project/ns/$namespace/billing': {
      id: '/_context/orgs/$organization/projects/$project/ns/$namespace/billing'
      path: '/billing'
      fullPath: '/orgs/$organization/projects/$project/ns/$namespace/billing'
      preLoaderRoute: typeof ContextOrgsOrganizationProjectsProjectNsNamespaceBillingRouteImport
      parentRoute: typeof ContextOrgsOrganizationProjectsProjectNsNamespaceRoute
    }
  }
}

interface ContextNsNamespaceRouteChildren {
  ContextNsNamespaceSettingsRoute: typeof ContextNsNamespaceSettingsRoute
  ContextNsNamespaceIndexRoute: typeof ContextNsNamespaceIndexRoute
}

const ContextNsNamespaceRouteChildren: ContextNsNamespaceRouteChildren = {
  ContextNsNamespaceSettingsRoute: ContextNsNamespaceSettingsRoute,
  ContextNsNamespaceIndexRoute: ContextNsNamespaceIndexRoute,
}

const ContextNsNamespaceRouteWithChildren =
  ContextNsNamespaceRoute._addFileChildren(ContextNsNamespaceRouteChildren)

interface ContextOrgsOrganizationProjectsProjectNsNamespaceRouteChildren {
  ContextOrgsOrganizationProjectsProjectNsNamespaceBillingRoute: typeof ContextOrgsOrganizationProjectsProjectNsNamespaceBillingRoute
  ContextOrgsOrganizationProjectsProjectNsNamespaceConnectRoute: typeof ContextOrgsOrganizationProjectsProjectNsNamespaceConnectRoute
  ContextOrgsOrganizationProjectsProjectNsNamespaceDeploymentsRoute: typeof ContextOrgsOrganizationProjectsProjectNsNamespaceDeploymentsRoute
  ContextOrgsOrganizationProjectsProjectNsNamespaceLogsRoute: typeof ContextOrgsOrganizationProjectsProjectNsNamespaceLogsRoute
  ContextOrgsOrganizationProjectsProjectNsNamespaceMetricsRoute: typeof ContextOrgsOrganizationProjectsProjectNsNamespaceMetricsRoute
  ContextOrgsOrganizationProjectsProjectNsNamespaceSettingsRoute: typeof ContextOrgsOrganizationProjectsProjectNsNamespaceSettingsRoute
  ContextOrgsOrganizationProjectsProjectNsNamespaceTokensRoute: typeof ContextOrgsOrganizationProjectsProjectNsNamespaceTokensRoute
  ContextOrgsOrganizationProjectsProjectNsNamespaceIndexRoute: typeof ContextOrgsOrganizationProjectsProjectNsNamespaceIndexRoute
}

const ContextOrgsOrganizationProjectsProjectNsNamespaceRouteChildren: ContextOrgsOrganizationProjectsProjectNsNamespaceRouteChildren =
  {
    ContextOrgsOrganizationProjectsProjectNsNamespaceBillingRoute:
      ContextOrgsOrganizationProjectsProjectNsNamespaceBillingRoute,
    ContextOrgsOrganizationProjectsProjectNsNamespaceConnectRoute:
      ContextOrgsOrganizationProjectsProjectNsNamespaceConnectRoute,
    ContextOrgsOrganizationProjectsProjectNsNamespaceDeploymentsRoute:
      ContextOrgsOrganizationProjectsProjectNsNamespaceDeploymentsRoute,
    ContextOrgsOrganizationProjectsProjectNsNamespaceLogsRoute:
      ContextOrgsOrganizationProjectsProjectNsNamespaceLogsRoute,
    ContextOrgsOrganizationProjectsProjectNsNamespaceMetricsRoute:
      ContextOrgsOrganizationProjectsProjectNsNamespaceMetricsRoute,
    ContextOrgsOrganizationProjectsProjectNsNamespaceSettingsRoute:
      ContextOrgsOrganizationProjectsProjectNsNamespaceSettingsRoute,
    ContextOrgsOrganizationProjectsProjectNsNamespaceTokensRoute:
      ContextOrgsOrganizationProjectsProjectNsNamespaceTokensRoute,
    ContextOrgsOrganizationProjectsProjectNsNamespaceIndexRoute:
      ContextOrgsOrganizationProjectsProjectNsNamespaceIndexRoute,
  }

const ContextOrgsOrganizationProjectsProjectNsNamespaceRouteWithChildren =
  ContextOrgsOrganizationProjectsProjectNsNamespaceRoute._addFileChildren(
    ContextOrgsOrganizationProjectsProjectNsNamespaceRouteChildren,
  )

interface ContextOrgsOrganizationProjectsProjectRouteChildren {
  ContextOrgsOrganizationProjectsProjectBillingRoute: typeof ContextOrgsOrganizationProjectsProjectBillingRoute
  ContextOrgsOrganizationProjectsProjectMetricsRoute: typeof ContextOrgsOrganizationProjectsProjectMetricsRoute
  ContextOrgsOrganizationProjectsProjectSettingsRoute: typeof ContextOrgsOrganizationProjectsProjectSettingsRoute
  ContextOrgsOrganizationProjectsProjectIndexRoute: typeof ContextOrgsOrganizationProjectsProjectIndexRoute
  ContextOrgsOrganizationProjectsProjectNsNamespaceRoute: typeof ContextOrgsOrganizationProjectsProjectNsNamespaceRouteWithChildren
}

const ContextOrgsOrganizationProjectsProjectRouteChildren: ContextOrgsOrganizationProjectsProjectRouteChildren =
  {
    ContextOrgsOrganizationProjectsProjectBillingRoute:
      ContextOrgsOrganizationProjectsProjectBillingRoute,
    ContextOrgsOrganizationProjectsProjectMetricsRoute:
      ContextOrgsOrganizationProjectsProjectMetricsRoute,
    ContextOrgsOrganizationProjectsProjectSettingsRoute:
      ContextOrgsOrganizationProjectsProjectSettingsRoute,
    ContextOrgsOrganizationProjectsProjectIndexRoute:
      ContextOrgsOrganizationProjectsProjectIndexRoute,
    ContextOrgsOrganizationProjectsProjectNsNamespaceRoute:
      ContextOrgsOrganizationProjectsProjectNsNamespaceRouteWithChildren,
  }

const ContextOrgsOrganizationProjectsProjectRouteWithChildren =
  ContextOrgsOrganizationProjectsProjectRoute._addFileChildren(
    ContextOrgsOrganizationProjectsProjectRouteChildren,
  )

interface ContextOrgsOrganizationRouteChildren {
  ContextOrgsOrganizationIndexRoute: typeof ContextOrgsOrganizationIndexRoute
  ContextOrgsOrganizationProjectsProjectRoute: typeof ContextOrgsOrganizationProjectsProjectRouteWithChildren
  ContextOrgsOrganizationNewIndexRoute: typeof ContextOrgsOrganizationNewIndexRoute
  ContextOrgsOrganizationProjectsIndexRoute: typeof ContextOrgsOrganizationProjectsIndexRoute
}

const ContextOrgsOrganizationRouteChildren: ContextOrgsOrganizationRouteChildren =
  {
    ContextOrgsOrganizationIndexRoute: ContextOrgsOrganizationIndexRoute,
    ContextOrgsOrganizationProjectsProjectRoute:
      ContextOrgsOrganizationProjectsProjectRouteWithChildren,
    ContextOrgsOrganizationNewIndexRoute: ContextOrgsOrganizationNewIndexRoute,
    ContextOrgsOrganizationProjectsIndexRoute:
      ContextOrgsOrganizationProjectsIndexRoute,
  }

const ContextOrgsOrganizationRouteWithChildren =
  ContextOrgsOrganizationRoute._addFileChildren(
    ContextOrgsOrganizationRouteChildren,
  )

interface ContextRouteChildren {
  ContextIndexRoute: typeof ContextIndexRoute
  ContextNsNamespaceRoute: typeof ContextNsNamespaceRouteWithChildren
  ContextOrgsOrganizationRoute: typeof ContextOrgsOrganizationRouteWithChildren
  ContextNewIndexRoute: typeof ContextNewIndexRoute
}

const ContextRouteChildren: ContextRouteChildren = {
  ContextIndexRoute: ContextIndexRoute,
  ContextNsNamespaceRoute: ContextNsNamespaceRouteWithChildren,
  ContextOrgsOrganizationRoute: ContextOrgsOrganizationRouteWithChildren,
  ContextNewIndexRoute: ContextNewIndexRoute,
}

const ContextRouteWithChildren =
  ContextRoute._addFileChildren(ContextRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  ContextRoute: ContextRouteWithChildren,
  AcceptInvitationRoute: AcceptInvitationRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  JoinRoute: JoinRoute,
  LoginRoute: LoginRoute,
  OnboardingRoute: OnboardingRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  VerifyEmailPendingRoute: VerifyEmailPendingRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
